import alt from "../alt";

class ConfigActions {
  fetch() {
    return "nothing";
  }

  setConfig(config) {
    return config;
  }

  saveConfig(config) {
    return config;
  }
}

/**
 * @deprecated Use {@link useDeviceOptionsStore} instead.
 *
 * TODO(@kristjan): This will be removed by https://familyzone.atlassian.net/browse/CF-320
 */
export default alt.createActions(ConfigActions);
